module.exports = __webpack_public_path__ + "static/media/woman.fd0a1058.jpg";